exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".item-title[data-v-047edcc1]{font-size:16px;font-weight:500;margin-bottom:10px}.el-input[data-v-047edcc1],.el-select[data-v-047edcc1]{width:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-047edcc1&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/InfoFlowAdShield.vue
// module id = 429
// module chunks = 0